/**
 * User: Rob Richard
 * Date: 5/15/14
 * Time: 6:41 PM
 */

"use strict";
var _ = require('underscore');
var Anchor = require('bunsen/models/Anchor');
module.exports = require('bunsen/collections/SoaCollection').extend();

_.extend(module.exports.prototype, {
    model: Anchor,
    getAnchorByType: function (anchorType) {
        return this.findWhere({ sourceType: anchorType });
    },
    getAnchorIdByType: function (anchorType) {
        var anchor = this.getAnchorByType(anchorType);
        return anchor ? anchor.get('sourceId') : null;
    },
    hasAnchor: function (anchorType) {
        return !!this.getAnchorIdByType(anchorType);
    },
    setAnchorId: function (anchorType, id) {
        var anchor = this.getAnchorByType(anchorType);
        if (anchor) {
            anchor.set('sourceId', id);
        }
        return this;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/Anchors.js
// module id = 330
// module chunks = 63